import UnitsSidePanel from './units-side-panel'

export default UnitsSidePanel
